import {observer, React} from '@api'
import {usePresentationPageViewStore} from './PresentationPageView'
import * as css from './PageTitle.css'

export const PresentationPageTitle = observer(function PresentationPageTitle() {
  const store = usePresentationPageViewStore(),
    {page, thumbnail, itemCountLabel} = store

  if (!page) return null

  const {pageTitle, pageSubTitles} = store

  return (<div className={css.titleBar}>
    {pageTitle && <span className={css.title} data-type='title'>{pageTitle}</span>}
    {thumbnail && itemCountLabel ? <span className={css.count}>({itemCountLabel})</span> : null}

    {!_.isEmpty(pageSubTitles) &&
	 <div className={css.subtitles} data-type='subtitles'>
       {pageSubTitles.map((pst, i) => <div className={css.subtitle} key={i}>{pst.label}</div>)}
	 </div>}
  </div>)
})


// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/PresentationMode/pageContents/PageTitle.tsx